import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import translate from '../../libs/i18n';

import InstitutionItem from '../InstitutionItem/InstitutionItem';
import EmptyListWarning from '../EmptyListWarning/EmptyListWarning';

import { InstitutionListStyle } from './InstitutionListStyle';

const InstitutionList = ({
  institutionList,
  galleryMode,
  handleDeleteUnit,
  handleOpenEditInstitutionForm,
}) => {
  const language = useSelector((state) => state.settings.language);
  return (
    <InstitutionListStyle>
      <div className={`institutions-list-table-head${galleryMode}`}>
        <div className="institution-name-item table-head-item">
          {translate('Institution', language)}
        </div>
        <div className="registration-item table-head-item">
          {translate('registrations', language)}
        </div>
        <div className="exams-item table-head-item">
          {translate('examsThisMonth', language)}
        </div>
        <div className="administrator-item table-head-item">Administrator</div>
        <div className="actions-item table-head-item">Actions</div>
      </div>
      {institutionList?.length ? (
        <ul className={`institutions-list-data${galleryMode}`}>
          {institutionList?.map((institution) => {
            return institution ? (
              <InstitutionItem
                key={institution?.id}
                institutionItem={institution}
                galleryMode={galleryMode}
                handleDeleteUnit={handleDeleteUnit}
                handleOpenEditInstitutionForm={handleOpenEditInstitutionForm}
              />
            ) : null;
          })}
        </ul>
      ) : (
        <div className="warning">
          <EmptyListWarning
            messages={{
              firstMessage: 'No results',
              secondMessage: translate('noResultsDescription', language),
            }}
          />
        </div>
      )}
    </InstitutionListStyle>
  );
};

InstitutionList.propTypes = {
  institutionList: PropTypes.arrayOf(PropTypes.object),
  galleryMode: PropTypes.string,
  handleDeleteUnit: PropTypes.func.isRequired,
  handleOpenEditInstitutionForm: PropTypes.func.isRequired,
};

InstitutionList.defaultProps = {
  institutionList: [],
  galleryMode: '',
};

export default InstitutionList;
